import React from 'react';
import {Avatar, Col, Divider, Row} from 'antd';

import './styles/AppContent.less';
import CVBlock from './components/CVBlock';
import avatar_png from '../images/avatar.png';


class AppContent extends React.Component {
  render() {
    return (
      <Row>
        <Col md={8} xl={7}>
          <Avatar size={160} src={avatar_png} />
        </Col>
        <Col md={16} xl={17}>
          <h1>Touko Hoshino</h1>
        </Col>
        <CVBlock
          title="About Me"
          content={`
I'm now a **Ph. D. student** at **Future Network Innovation Lab**, Fudan University, **supervised by Y. Chair Prof. Yang Xu**.
My major is **Cyberspace Security**, and my research area is **Data Center Network**
My current works are: 
- CDN
- Distributed Machine Learning
- Edge Computing 
I was an **undergraduate student** at Hongyi College, Wuhan University, majoring in **Computer Science**. I received my **Bachelor's Degree with Honors** at Jun. 2020.
I was a **full stack intern** at NineChapter Inc., using **Docker** to develop a code evaluation machine, maintaining the **React** frontend and the **Django** backend.
`}
        />
        <CVBlock
          title="Educations"
          content={`
- **Ph. D. at School of Computer Science and Technology, Fudan University**, Shanghai, China
  Sep. 2020 - Jun. 2025 (estimate)
- **B. S. with Honors at Hongyi College, Wuhan University**, Wuhan, China
  Sep. 2016 - Jun. 2020
`}
        />
        <CVBlock
          title="Experiences"
          content={`
- **Research Assistant at FNIL, Fudan University**, research on **CDN and distributed machine learning**.
  2019.10 - 2020.8'
- **Full Stack Intern Developer at Nine Chapter Inc.**, focus on **Docker, Django and React**.
  2018.2 - 2019.11' 
`}
        />
        <CVBlock
          title="Rewards"
          content={`
- **Silver Award** at the 2019 CCF Collegiate Computer System & Programming contest (CCSP) 
  Oct. 2019
- **Silver Award** at the 2019 ACM-ICPC China Xian National Invitational Programming Contest 
  May 2019
- **First prize** at Dora Hacks Summer in Wuhan Hackathon, Dora Hacks 
  Jun. 2018
- **Meritorious Winner (Top 6% of 9932 teams)** at MCM/ICM (Problem D), the COMAP
  Feb. 2018
- **Second prize (Top 1% of 800 teams)** at Beauty of Programming 2017, Microsoft Research Asia
  Aug. 2017 
`}
        />
        <CVBlock
          title="Scholarships"
          content={`
- **C-class Scholarship (Top 20% of 36)** in Wuhan University 
  2019
- **B-class Outstanding Student (Top 20% of all)** in Wuhan University  
  2019
- **B-class Scholarship (Top 15% of 36)** in Wuhan University  
  2018
- **B-class Outstanding Student (Top 20% of all)** in Wuhan University  
  2018 
`}
        />
        <CVBlock
          title="Publications"
          content={`
- The Best Beautiful Path , Patent of Invention (Substantive reviewing), **Third Author**
  2017 
`}
        />
      </Row>
    );
  }
}

export default AppContent;